import Moment from 'moment'

export default {
  methods: {
    getComparePeriodHint (pastDurationMoment, pastToCurrentComparePercent) {
      const { past, current } = pastDurationMoment
      const { after, before } = past

      const haveDifference = pastToCurrentComparePercent
        ? ''
        : this.$tr('analytics.widgets.compare.noChanges')
      let comparePeriod = ''

      // If we compare to period that ends today maybe
      // it is default week / month / year preset comparison.
      const today = Moment().startOf('day')

      const isPeriodEndsToday = today.diff(current.before) === 0
      if (isPeriodEndsToday) {
        const dif = after.diff(before)

        const isWeekDiff = today.clone().subtract(7, 'days').diff(today)
        const isMonthDiff = today.clone().subtract(1, 'month').diff(today)
        const isYearDiff = today.clone().subtract(1, 'year').diff(today)

        switch (dif) {
          case isWeekDiff:
            comparePeriod = this.$tr('analytics.widgets.compare.pastWeek')
            break

          case isMonthDiff:
            comparePeriod = this.$tr('analytics.widgets.compare.pastMonth')
            break

          case isYearDiff:
            comparePeriod = this.$tr('analytics.widgets.compare.pastYear')
            break

          default:
            break
        }
      }

      if (comparePeriod === '') {
        const currentLocale = this.$store.getters['locale/current']

        if (after.diff(before) !== 0) {
          comparePeriod = this.$tr('analytics.widgets.compare.period') +
            Moment(after).locale(currentLocale).format('LL') +
            ' - ' +
            Moment(before).locale(currentLocale).format('LL')
        } else {
          comparePeriod = Moment(after).locale(currentLocale).format('LL')
        }
      }

      if(this.localeJp) {
        return `${haveDifference} ${comparePeriod} ${this.$tr('analytics.widgets.compare.compareWith')}`
      } else {
        return `${haveDifference} ${this.$tr('analytics.widgets.compare.compareWith')} ${comparePeriod}`
      }
    }
  },

  computed: {
    localeJp () {
      return this.$store.getters['locale/current'] === 'ja';
    }
  }
}
